import { ListFormat } from '../enums/list-format.enum';

export abstract class ListViewItemInterface {
  listFormat: ListFormat;
}
